var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitingForApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.0002,
    r: 12,
    transform: "rotate(-178.971 13 13.0002)",
    fill: "#D87228"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.9517,
    y: 15.7031,
    width: 3.99999,
    height: 10.6666,
    rx: 2,
    transform: "rotate(-178.971 14.9517 15.7031)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.856,
    y: 21.0352,
    width: 3.99999,
    height: 3.99999,
    rx: 2,
    transform: "rotate(-178.971 14.856 21.0352)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingForApproval);
export default __webpack_public_path__ + "static/media/waiting-for-approval.f306f6c29fe7e7dc3e8e094e571ebc11.svg";
export { ForwardRef as ReactComponent };